function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { ViewArchiveFile } from "../../../tools";
import { ViewPdf } from "./view-pdf.component";
export const ViewArchivePdf = props => {
  var _props$name;
  // TODO keep or not static urls?? -> NO
  const dataRange = props.archive.httpUrl; // ?? props.archive.staticUrl
  return /*#__PURE__*/React.createElement(React.Fragment, null, dataRange ? /*#__PURE__*/React.createElement(ViewPdf, _extends({
    dataRange: {
      url: dataRange.url,
      name: (_props$name = props.name) !== null && _props$name !== void 0 ? _props$name : 'document.pdf' // TODO default name ... with { t } i18n ?
    }
  }, props.common, props.pdf)) : /*#__PURE__*/React.createElement(ViewArchiveFile, props, file => /*#__PURE__*/React.createElement(ViewPdf, _extends({
    file: file
  }, props.common, props.pdf))));
};